/**
 * Created by hashinig on 11/5/18.
 */
(function () {
  'use strict';

  angular
    .module('trainingRoster')
    .controller('TrainingCrewAssignmentCtrl', TrainingCrewAssignmentCtrl);

  function TrainingCrewAssignmentCtrl($uibModalInstance, modalParams, MessageService,$timeout,StorageServices,TabService,applicationConstants) {
    var vm = this;

    vm.model = {
      selectedExpiry:null,
      title:null,
      isAssigned:false,
      rosterCycle:null
    };

  vm.model.selectedExpiryCrew = modalParams.selectedRow;
  vm.model.title = modalParams.title;
  vm.model.isAssigned = modalParams.isAssigned;
  vm.model.rostarCycle = modalParams.rosterCycle;

    vm.clickOnCrewId = function ($event, $index, crewData) {
      console.log(crewData);
      console.log(vm.model.rostarCycle);
      var tabName = 'crewSchedule';
      var mo = moment(vm.model.rostarCycle.dateFrom, applicationConstants.SETTINGS.DATE_FORMAT);
      var moStart = moment(mo.startOf("month"));
      var moEnd = moment(mo.endOf("month"));
      var crewId = crewData.crewId;

      StorageServices.setTabData(tabName, 'crewingParams', {
        crewId: crewId,
        fromDate: moStart.format(applicationConstants.SETTINGS.DATE_FORMAT),
        toDate: moEnd.format(applicationConstants.SETTINGS.DATE_FORMAT)
      });
      TabService.gotoTab(tabName, {
        crewId: crewId
      });
    };

  }
}());
